import type {Operand} from '../types/expression-types';
import type {Serializable} from '../types/serialized-cohort-types';
import {ExpressionNode} from './expression-node';

// TODO: Share these with property-filter-menu/models/selector-tree/
export class OperandNode extends ExpressionNode implements Serializable {
  constructor(public operand: Operand, public left: ExpressionNode = null, public right: ExpressionNode = null) {
    super(left, right);
  }

  public serialize(): Operand {
    return this.operand;
  }
}
